/**
 * テーマAPIフック
 * TanStack Queryを使用したデータフェッチング
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { themeApi } from './index';
import type { UserPreference, UpdateUserPreferenceData } from '../types';
import { notifications } from '@mantine/notifications';
import { useAuth } from '../../auth/contexts/AuthContext';

// クエリキーの定義
const QUERY_KEYS = {
  preferences: ['user-preferences'] as const,
};

// 設定取得フック
export const useUserPreferences = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: QUERY_KEYS.preferences,
    queryFn: themeApi.getPreferences,
    staleTime: 5 * 60 * 1000, // 5分間キャッシュ
    enabled: !!user, // ユーザーがログインしている場合のみ実行
  });
};

// 設定更新フック
export const useUpdateUserPreferences = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: themeApi.updatePreferences,
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEYS.preferences, data);
      notifications.show({
        title: '設定更新',
        message: '設定を保存しました',
        color: 'green',
      });
    },
    onError: () => {
      notifications.show({
        title: 'エラー',
        message: '設定の保存に失敗しました',
        color: 'red',
      });
    },
  });
};